import { Box, Grid, styled, Typography, useMediaQuery } from "@mui/material";
import { YRFLogo } from "images";
import React, { useState } from "react";
import DocumentTitle from "react-document-title";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

const PrivacyContainer = styled("div")(({ theme }) => ({
  fontFamily: "'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
  lineHeight: 1.8,
  color: "#333333",
  margin: 0,
  padding: 0,
}));

const HeaderSection = styled("header")(({ theme }) => ({
  backgroundColor: "#ffffff",
  borderBottom: "2px solid #f0f0f0",
  padding: "40px 20px",
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    padding: "30px 15px",
  },
  "& img": {
    maxHeight: "150px",
    marginBottom: "20px",
  },
  "& h1": {
    margin: "20px 0 10px",
    fontSize: "2.5rem",
    fontWeight: 700,
    color: "#1a1a1a",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.8rem",
    },
  },
}));

const MainContent = styled("main")(({ theme }) => ({
  maxWidth: "900px",
  margin: "0 auto",
  padding: "40px 30px",
  [theme.breakpoints.down("sm")]: {
    padding: "20px 15px",
  },
  "& h2": {
    fontSize: "1.3rem",
    fontWeight: 700,
    marginTop: "30px",
    marginBottom: "15px",
    color: "#1a1a1a",
    borderBottom: "2px solid #007bff",
    paddingBottom: "10px",
  },
  "& h3": {
    fontSize: "1.1rem",
    fontWeight: 600,
    marginTop: "20px",
    marginBottom: "12px",
    color: "#333333",
  },
  "& p": {
    marginBottom: "15px",
    textAlign: "justify",
    fontSize: "0.95rem",
  },
  "& ul, & ol": {
    marginLeft: "20px",
    marginBottom: "15px",
  },
  "& li": {
    marginBottom: "10px",
    textAlign: "justify",
  },
  "& strong": {
    fontWeight: 600,
    color: "#1a1a1a",
  },
  "& a": {
    color: "#007bff",
    textDecoration: "none",
    "&:hover": {
      color: "#007bff",
      textDecoration: "underline",
    },
  },
}));

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <DocumentTitle title={"Privacy Policy"}>
      <>
        <Helmet>
          <link rel="stylesheet" type="text/css" href="css/styles.css" />
        </Helmet>
        <PrivacyContainer>
          <section id="logo-home">
            <img
              src={YRFLogo}
              style={{ height: "250px", width: "250px", borderRadius: "5px" }}
            />
          </section>
          <HeaderSection>
            {/* <img
              src={YRFLogo}
              alt="Luv Films Logo"
              style={{ height: "200px" }}
            /> */}
            <h1>PRIVACY POLICY</h1>
          </HeaderSection>

          <MainContent>
            <p>
              The service/ platform currently branded as{" "}
              <strong>Luv Films Casting</strong> ("Platform") which is owned,
              operated and managed by <strong>Luv Films LLP</strong> ("Company")
              that is being accessed and used by you, the user ("you/ your/
              User") of the Platform, is committed to protecting the privacy of
              its Users.
            </p>
            <p>
              By accessing the Platform, you signify your agreement to accept
              this privacy policy ("Policy"). If you do not agree with any of
              the following terms of this Policy, please do not access the
              Platform and/ or use its services.
            </p>
            <p>
              This Policy is subject to change/ amendments/ modifications/
              alterations based on changes in the legal requirements, business,
              regulatory changes and the updated Policy shall be accessible to
              you on the Platform and shall be effective from the moment of
              availability of such updated Policy on the Platform, from time to
              time. Your continued use of the Platform pursuant to any change in
              the Policy shall be deemed an acceptance of the Policy. The
              Platform hereby encourages the User to view the Policy
              periodically to keep updated with any changes made to the Policy.
              Any such change in the Policy which materially lessens the
              Platform's commitment to you shall be communicated to you via
              prominent notices or other appropriate means.
            </p>
            <p>
              This Policy explains how and why the Platform uses personal data
              [also known as personal information and/ or personally
              identifiable information ("PII")]. Examples of PII are as follows:
              (i) passwords; (ii) personal information; (iii) email address; and
              (iv) any national methods of identification;(v) social media
              links.
            </p>
            <p>
              However, the User must note that any information that is freely
              available or accessible in public domain or furnished under the
              Right to Information Act, 2005 or any other law for the time being
              in force shall not be regarded as PII for the purposes of this
              Policy and the Platform shall not be obliged to take any measures
              to protect any information that is freely available in the public
              domain.
            </p>
            <p>
              1.The Platform does not knowingly collect PII from individuals who
              are under the minimum required ages specified herein. You must be
              at least 18 years old or the age of majority in your jurisdiction,
              whichever is greater, to use the Platform. Individuals under the
              applicable age may use the Platforms only through a parent or
              legal guardian's account and with their involvement.
            </p>
            <h2>2. Collection: What kind of data/ PII is collected?</h2>
            <p>
              a. Account information/ information provided by you The
              information provided by you while creating an account to access
              the Platform, including but not limited to your PII and/ or data
              provided by you/ volunteered to be provided by you while accessing
              and using the Platform may be collected by the Platform.
            </p>

            <p>
              b. Information from affiliates- The Platform may collect
              information from third party companies that you are in association
              with/ in affiliation with/ in a relationship with ("Affiliates").
              These Affiliates may include your internet service provider,
              mobile phone carriers, other companies who provide services to you
              in relation with the Platform (payment gateways, internet
              browsers), etc. Such information collected by Affiliates would
              include: (i) search queries and commands applicable to the
              Platform made through Affiliate devices or voice assistants; (ii)
              device IDs and unique identifiers like user interface information,
              the Platform registration user experience, etc.; and (iii)
              Platform activation system including but not limited to contact
              information.
            </p>
            <h3></h3>
            <p>
              c. Other information: Any and all information collected from other
              sources in relation to the Platform including but not limited to
              (i) service providers that help the Platform determine a location
              based on your IP address in order to customize the Platform for
              you and for any other uses consistent with this Policy; (ii)
              security service providers that provide the Platform with
              information to secure the Platform's systems, prevent fraud and
              help the Platform protect the security of the Users accounts;
              (iii) payment service providers that provide the Platform with
              payment or balance information, or updates to that information,
              based on their relationship with you; or (iv) publicly-available
              sources such as publicly available posts on social media platforms
              and information available through public databases associating IP
              addresses with internet service providers (ISPs). Please note that
              the sources of the aforementioned information are varying, from
              time to time.
            </p>
            <p>
              <strong>
                3. THE PLATFORM SHALL NEVER MANDATE YOU TO PROVIDE YOUR PII/
                SENSITIVE INFORMATION/ TO THE PLATFORM OR TO ANY AFFILIATE/ ANY
                ENTITY REPRESENTING THE PLATFORM. ANY DISCLOSURE OF SENSITIVE
                PERSONAL INFORMATION/ DATA SHALL BE AT THE SOLE RISK OF THE USER
                AND WITHOUT ANY LIABILITY TO THE PLATFORM (INCLUDING ITS
                ASSIGNEES, LICENSEES, SUB-LICENSEES, AFFILIATES, OFFICERS,
                DIRECTORS, AND EMPLOYEES).
              </strong>{" "}
              You understand, acknowledge and agree that the Platform or any
              other person/ entity acting on behalf of the Platform shall not in
              any manner be responsible for the authenticity of the sensitive
              personal information, or personal data or any other sensitive
              information provided by you to the Platform. The Platform shall
              not be liable or shall not be held responsible for any damage,
              loss, misuse of your data due to any reason attributable to a
              force majeure event.
            </p>
            <p>
              4.Please note that the Platform or any entity representing the
              Platform shall in no event ask for your sensitive information
              including financial information like debit card/ credit card
              number, financial pin numbers, etc. In the event of your access to
              the Platform requires any type of payment service(s), the
              information related to such third party service/ payment gateway
              shall be collected by such third party services and/ or payment
              gateway engaged by the Platform to facilitate such use by you of
              the Platform and the such data shall not be stored by the Platform
              in any event save and except only to the extent necessary. Since
              such private information shall be processed and accessed by such
              third party payment aggregator, the User is encouraged to read the
              privacy policies of such third party services. You acknowledge and
              agree that the Platform shall not be liable for any collection,
              access and processing of data by the payment gateway.
            </p>

            <p>
              <b>Use of information</b>: The Platform uses information to for
              registration and creation of an account on the Platform.
              Verification of User age to ensure that our services are
              appropriately directed to all users, and communicating with you
              regarding updates, events, including casting calls, call-backs,
              scheduled auditions, and submission of further information, where
              necessary.
            </p>
            <h2>5. For example, the Platform uses such information to:</h2>
            <ul>
              <li>
                Help the Platform to quickly and efficiently respond to
                inquiries and requests;
              </li>
              <li>
                Coordinate with Affiliates on making the Platform available to
                members of the Platform and providing information to non members
                about the availability of the Platform, based on the specific
                relationship you have with the Affiliate;
              </li>
              <li>
                Secure the Platform's systems, prevent fraud and help the
                Platform protect the security of the Platform's accounts;
              </li>
              <li>
                Communicate with you concerning the Platform so that the
                Platform can send you news about the Platform, details about new
                features and on the Platform, special offers, consumer surveys,
                and to assist you with operational requests such as password
                change requests. These communications may be by various methods,
                such as email, push notifications, text message, online
                messaging channels such as email.
              </li>
              <li>
                Complete your Account creation/ registration processes,
                including providing One Time Password (OTP) on your registered
                mobile number for activating and/ or logging-in your Account on
                the Platform.
              </li>
              <li>
                To gather demographic and device information about the user base
                as a whole. The Platform may use this information in its
                advertising services. The Platform may also use such information
                to measure sales and traffic patterns on the Platform,
                advertising interactions and effectiveness and advertisement
                identifiers and general enhancement of the Platform.
              </li>
            </ul>
            <p>
              <b>6. Collection of information:</b> The Platform may use certain
              methods to collect information about your subject to the device
              and/or the browser you access the Platform with/ by and at the
              Platform's sole discretion. Electronic identifiers refer to unique
              digital information that may be associated with your device and/or
              your browser when you access the Platform ("Electronic
              Identifiers").
            </p>
            <p>
              a. The Electronic Identifiers shall include but not limit (i)
              cookies that are small text files that are stored on your device
              (computer, smartphone, tablet, etc.), when you visit/ use/ access
              the Platform ("Cookies"); and (ii) other device/ electronic
              identifiers may include pixel tags, web beacons, local storage,
              and similar technologies that perform similar functions. These
              Cookies contain information that allows the Platform to recognize
              your device/ browser during subsequent visits.
            </p>
            <p>
              b. Such Electronic Identifiers may also store data on your device
              and/ or the browser. Such methods shall/ may attach a unique
              identification ("User ID") to the User and unless the User ID is
              voluntarily identified by you using your registration data, the
              Platform will be unaware of your identity at all times. Third
              party companies may place cookies/ electronic identifiers to their
              advertisements which is beyond the control of the Platform and the
              Platform disclaims any damages/ losses arising due to your
              clicking of such advertisements. The Platform may place temporary
              or permanent Electronic Identifiers in your device(s). You have
              the option to manage and control the acceptance of Electronic
              Identifiers through your browser or device settings, the
              consequences of such management of Electronic Identifiers
              including Cookies shall vary at the sole discretion of the
              Platform. Most web browsers allow you to control the use of
              cookies and other similar technologies, including web beacons and
              pixel tags.
            </p>
            <h3>c. Choosing Electronic Identifiers</h3>
            <ul>
              <li>
                <strong>To manage Cookies:</strong> You may choose to prevent
                installation of Cookies through your browser settings and
                configure your browser to set your cookie preferences.
              </li>
              <li>
                <strong>To manage the resettable device identifiers:</strong> To
                opt out of behavioural ads from the Platform in connection with
                a resettable device identifier on a mobile device, tablet, or
                streaming media devices, please configure the appropriate
                setting on your device in the device settings. You may still see
                the Platform ads on your device, but they will not be selected
                based on your likely interests.
              </li>
              <li>
                <strong>To manage other technologies:</strong> There are a
                number of ways to exercise choice regarding technologies that
                are similar to cookies, such as browser storage and plugins
                (e.g., HTML5, IndexedDB, and WebSQL). For example, many popular
                browsers provide the ability to clear browser storage, commonly
                in the settings or preferences area. The users are recommended
                to see your browser's help function or support area to learn
                more.
              </li>
            </ul>
            <p>
              By continuing to use the Platform, you consent to the use of
              Cookies and other device identifiers in accordance with this
              Policy. If you do not agree to the use of Electronic Identifiers,
              you should discontinue using the Platform or manage your
              Electronic Identifiers as aforesaid above.
            </p>
            <h2>7. Disclosure of information</h2>
            <p>
              The information available with the Platform in relation to the
              User may be disclosed under the following circumstances:
            </p>
            <ul>
              <li>
                A. The Platform may share your information among the Company's
                employees/ representatives.
              </li>
              <li>
                B. <strong>Service Providers:</strong> The Platform uses other
                companies, agents or contractors ("Service Providers") to
                perform services on the Platform's behalf or to assist the
                Platform with the provision of services to you. For example, the
                Platform engages Service Providers to provide advertising,
                security, infrastructure and IT services, to customize,
                personalize and optimize the Platform, for legal purposes, for
                payment methods, to provide customer service and to process and
                administer consumer surveys, etc. In the course of providing
                such services, these Service Providers may have access to your
                personal or other information. The Platform does not authorize
                them to use or disclose your PII except in connection with
                providing their services and has contracts with them to govern
                how the personal data may be used.
              </li>
              <li>
                C. <strong>Affiliates:</strong> As described above, you may have
                a relationship with one or more of the Platform's Affiliates, in
                which case the Platform may share certain information with them
                in order to coordinate with them on providing the Platform to
                members and providing information about the availability of the
                Platform.
              </li>
              <li>
                D. <strong>Protection of the Platform and others:</strong> The
                Platform and its service providers may disclose and otherwise
                use your personal and other information to locations inside and
                outside India (as applicable) where the Platform or they
                reasonably believe such disclosure is needed to (a) satisfy any
                applicable law, regulation, legal process, or governmental
                request, (b) enforce applicable terms of use, including
                investigation of potential violations thereof, (c) detect,
                prevent, or otherwise address illegal or suspected illegal
                activities (including payment fraud), security or technical
                issues, or (d) protect against harm to the rights, property or
                safety of the Platform, its users or the public, as required or
                permitted by law. The Platform will share personal data where
                necessary to establish, exercise or defend the Platform's legal
                rights.
              </li>
              <li>
                E. <strong>Business transfers:</strong> In connection with any
                reorganization, restructuring, merger or sale, or other transfer
                of assets, the Platform will transfer information, including
                PII, provided that the receiving party agrees to respect your
                PII in a manner that is consistent with the Platform's Policy.
              </li>
              <li>
                F. Whenever in the course of sharing information the Platform
                transfers PII to other countries, the Platform will ensure that
                the PII is transferred in accordance with this Policy, with
                appropriate security measures in place and as permitted by the
                applicable laws on data protection.
              </li>
              <li>
                G. Social media:The user and social media subscribers and other
                individuals may engage with the Platform through third-party
                social networks (for example, Facebook, X and Pinterest). The
                Platform may also allow Users to access their accounts through
                social networks. Where Users or other individuals engage or
                login through social media, the Platform will share personal
                data with and receive personal data from the relevant social
                network. Where Users or individuals engage or login through a
                social network, the Platform encourages that they read the
                relevant social network's privacy policy.
              </li>
              <li>
                H. You may also choose to disclose your information in the
                following ways: (i) certain portions of the Platform may contain
                a tool which gives you the option to share information by email,
                text message and social or other sharing applications, using the
                applications on your smart device; and (ii) social plugins and
                similar technologies allow you to share information. Social
                plugins and social applications are operated by the social
                networks themselves, and are subject to their terms of use and
                privacy policies.
              </li>
            </ul>

            <p>
              8. The Platform uses commercially reasonable security measures,
              practices, methods and procedures, at the minimum, mandated under
              the Information Technology Act, 2000 as amended and read with
              Information Technology (Reasonable Security Practices and
              Sensitive Personal Data or Information) Rules, 2011, to safeguard
              and protect your information and data. Such measures are
              implemented by the Platform to protect any unauthorised access to
              and unlawful interception of PII. You accept, acknowledge and
              confirm that there is an inherent security risk of providing any
              kind of information over internet/ cellular networks and
              understand and accept that the Platform cannot guarantee the
              absolute security of your information. You agree to not hold the
              Platform responsible for any breach (threatened, alleged, or
              actual) of security or the disclosure of PII. You agree that
              disclosing any information by yourself is solely and completely at
              your own risk.
            </p>

            <p>
              <b>9. Storage of information (if any):</b> The information
              collected shall be stored in an electronic form, primarily,
              however, information may be stored in a physical form as well. You
              agree that the Platform may store, collect, process and use your
              data in locations/ jurisdictions outside the country of India and
              such data will be used in line and in compliance with applicable
              laws.
            </p>
            <p>
              <b>10. Retention of information:</b>
              The Platform shall store your data in full compliance with
              applicable laws and until as necessary to comply with legal
              obligations, enforce the Platform's policies and resolve
              complaints and/ or disputes. The Platform shall delete your
              information upon completion of the purpose of such information and
              shall be deleted in a secure method. For abundant clarity,
              deletion of your information shall exclude anonymous data
              collected through your use/ access of the Platform.
            </p>

            <p>
              <b>11.Access:</b>
              As per the applicable laws, should you wish to request access to
              information collected about you, you may place such request by
              contacting the Platform. The Platform provides with you all
              information that the Platform maintains about you such as the
              contact information, payment (transaction) information upon proper
              verification of the User at the time of request of such
              information. Proper verification shall include the following
              information at the time of contacting the Platform for any kind of
              information: (i) Your physical or electronic signature; and (ii)
              adequate information by which the Platform can contact you. You
              may also request to correct the information collected about you by
              contacting the Grievance Officer (mentioned below) and request the
              deletion of any information collected about you. Upon deletion of
              such information collected about you, you agree, acknowledge and
              confirm that such deletion may result in cancellation of your
              access to/ usage of the Platform and/ or certain features of the
              Platform. You agree and acknowledge that certain information
              collected about you cannot be deleted or corrected or prohibited
              to be deleted as required by any legal enforcement agency, under
              applicable laws and/ or for archival purposes.
            </p>
            <p>
              <b>Support: </b> If you have any queries, feedbacks or complaints
              regarding the Policy and/ or Platform, your access to the
              Platform, you may please avail the support and assistance of the
              support chat available on the Platform under 'support'. If you
              have any information, data, complaint, feedback regarding any of
              your information/ PII, please reach out to the Platform at{" "}
              <a href="mailto:casting@luvfilms.in">casting@luvfilms.in</a>.
            </p>
            <h2>12. Grievance Officer</h2>
            <p>
              The Grievance Officer is identified below pursuant to the
              provisions of applicable laws including but not limited to the
              Information Technology Act, 2000 and the rules enacted under those
              laws:
            </p>
            <p>
              <strong>Name:</strong> Vicky Sidana
              <br />
              <strong>Email:</strong>{" "}
              <a href="mailto:casting@luvfilms.in">casting@luvfilms.in</a>
            </p>
            <h2>13. Miscellaneous</h2>
            <p>
              This Policy shall be governed by and construed in accordance with
              the laws of India and the Courts at Mumbai shall have exclusive
              jurisdiction regarding any matter arising out of or related to
              this Policy.
            </p>
            <p>
              Each affiliate of the Platform is severally liable for its own
              obligations under this Policy and is not jointly liable for the
              obligations of other affiliates of the Platform. In addition, each
              affiliate of the Platform is solely responsible with respect to
              its exercise of its rights and compliance with its obligations in
              connection with the territory or territories for which it is
              responsible, as determined by the Platform in its sole discretion.
            </p>
            <p>
              If any provision of this Agreement is adjudged by a court to be
              void or unenforceable, the same shall in no way affect any other
              provision of this Agreement, or its validity or enforceability and
              the unenforceable provision shall be performed to the extent valid
              and enforceable.
            </p>
          </MainContent>
        </PrivacyContainer>
      </>
    </DocumentTitle>
  );
};

export default PrivacyPolicy;
